import { CUSTOM_GROUP_TYPE_OPTIONS } from './constants';

const mapItems = items => items.map(item => ({
  value: item.itemName,
  label: item.itemLabel,
  type: item.itemType,
}));

export default customGroup => {
  const selectedCustomGroupFields = {
    name: {
      value: customGroup
        ? customGroup.name
        : '',
      isValid: !!customGroup && Boolean(customGroup.name),
    },
    groupType: {
      value: customGroup && customGroup.groupType
        ? CUSTOM_GROUP_TYPE_OPTIONS.find(option => option.value === customGroup.groupType)
        : '',
      isValid: !!customGroup && Boolean(customGroup.groupType),
    },
    publicFlag: {
      value: customGroup && customGroup.publicFlag
        ? customGroup.publicFlag
        : false,
      isValid: !!customGroup && Boolean(customGroup.publicFlag),
    },
    archivalFlag: {
      value: customGroup && typeof customGroup.archivalFlag !== 'undefined'
        ? customGroup.archivalFlag
        : false,
      isValid: true,
    },
    sftpDeliveryFlag: {
      value: customGroup && typeof customGroup.sftpDeliveryFlag !== 'undefined'
        ? customGroup.sftpDeliveryFlag
        : false,
      isValid: true,
    },
    allowEditFlag: {
      value: customGroup && customGroup.allowEditFlag
        ? customGroup.allowEditFlag
        : false,
      isValid: !!customGroup && Boolean(customGroup.allowEditFlag),
    },
    groupItem: {
      value: customGroup && customGroup.groupItem
        ? mapItems(customGroup.groupItem)
        : [],
      isValid: !!customGroup && Boolean(customGroup.groupItem),
    },
  };

  return {
    formData: selectedCustomGroupFields,
    isFormDirty: false,
    isFormValid: !!customGroup && Boolean(customGroup.name),
    triedToSubmitForm: false,
    elementsToValidate: ['name'],
    shouldResetValues: false,
  };
};
